import { Brand } from '@domgen/dgx-fe-catalogue';
import { BrandCategoryAppliance } from '@domgen/dgx-fe-catalogue/lib/models/brand-category-appliance.interface';
import {
  CountryIso3Code,
  CurrencyCode,
  formatProvinceCode,
  USProvinceName,
} from '@domgen/dgx-fe-i18n';
import {
  ApplianceDetailsSteppedIpsFormValue,
  RegistrationChannel,
  RegistrationRequest,
  RegistrationSource,
  RegistrationSystemCode,
  SerializationCodeResponse,
} from '@us-registration/util-models';
import { format } from 'date-fns';
export function formatApplianceDetailsSteppedFormValueToWIBRegistrationRequest(
  formValue: ApplianceDetailsSteppedIpsFormValue,
  brandCategoryAppliance: BrandCategoryAppliance,
  brand: Brand,
  systemCode: RegistrationSystemCode,
  isAddressFormatted: boolean,
  serializationCodeResponse?: SerializationCodeResponse
) {
  const state = formatProvinceCode(
    formValue.personalDetails.ipsAddress.address.regionOrStateCode,
    USProvinceName
  );

  const registrationRequest: RegistrationRequest = {
    channel: RegistrationChannel.Web,
    client: 'Whirlpool',
    country: CountryIso3Code.UnitedStates,
    currency: CurrencyCode.USDollar,
    customer: {
      firstName: formValue.personalDetails.firstName,
      lastName: formValue.personalDetails.lastName,
      email: formValue.personalDetails.emailAddress,
      billingAddress: {
        line1: formValue.personalDetails.ipsAddress.address.addressLine1,
        line2: formValue.personalDetails.ipsAddress.address.addressLine2,
        city: formValue.personalDetails.ipsAddress.address.city,
        state: state
          ? state
          : formValue.personalDetails.ipsAddress.address.regionOrStateCode,
        postalCode: formValue.personalDetails.ipsAddress.address.postalCode,
        country: CountryIso3Code.UnitedStates,
        isFormatted: isAddressFormatted,
      },
      phone: { Home: formValue.personalDetails.telephoneNumber },
    },
    merchandise: [
      {
        brand: brand.brandCode,
        locatedAtMailingAddress: true,
        merchandiseInGoodWorkingOrder: true,
        modelNumber: formValue.modelAndSerialNumber.modelNumber,
        purchaseDate: format(
          new Date(formValue.purchaseDate as Date),
          'yyyy-MM-dd'
        ),
        purchasePrice: String(formValue.purchasePrice),
        serialNumber: formValue.modelAndSerialNumber.serialNumber,
        type: serializationCodeResponse
          ? serializationCodeResponse.applianceCode
          : brandCategoryAppliance.applianceCode,
      },
    ],
    system: systemCode,
  };

  return registrationRequest;
}

export function determineRegistrationSystemCode(
  modelNumber: string | undefined,
  registrationSource: string | undefined
): RegistrationSystemCode {
  if (registrationSource === RegistrationSource.QR) {
    return RegistrationSystemCode.QRCodeProductRegistration;
  }

  if (modelNumber && registrationSource === RegistrationSource.PR) {
    return RegistrationSystemCode.PhotoregProductRegistration;
  }

  return RegistrationSystemCode.InternetProductRegistration;
}
